<template>
  <div class="">
    <el-row :gutter="20">
      <el-col :span="2" :offset="0">

      </el-col>
      <el-col :span="3" :offset="1">
        <el-dropdown v-if="(id_project > 0) && (g_project.id_analysis_type > 0) && (g_examination_selected.status === 12) && selected_exams.length === 0" style="width: 100%; margin-top: 6px;  margin-bottom: 6px;">
          <el-button type="warning" size="small" style="width: 100%">
            Actions of CNV <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu v-if="id_biorole > 3" slot="dropdown">
            <el-dropdown-item v-if="vars_selected_tab != 'presel' && vars_selected_tab != 'sign' && g_examination.published.length === 0" icon="icofont-arrow-right" @click.native="preselect_cnv($event)">Move to Preselected CNV</el-dropdown-item>
            <el-dropdown-item v-if="vars_selected_tab === 'presel' && g_examination.published.length === 0" icon="icofont-arrow-left" @click.native="unpreselect_cnv($event)">Remove from Preselected CNV</el-dropdown-item>
            <el-dropdown-item v-if="vars_selected_tab != 'sign' && g_examination.published.length === 0" icon="icofont-prescription" @click.native="sign_out_cnv($event)">Move to Sign out CNV</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>

      <el-col :span="3">
        <el-dropdown v-if="g_examination_selected.status === 12" style="width: 100%; margin-top: 6px;  margin-bottom: 6px;">
          <el-button type="primary" size="small" style="width: 100%">
            Export of CNV <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="icofont-file-excel" divided @click.native="export_all_cnvs($event)">Export ALL CNV into XLSX File</el-dropdown-item>
            <el-dropdown-item icon="icofont-file-excel" @click.native="export_grid_cnvs($event)">Export CNV in Table into XLSX File</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>

      <el-col :span="5" :offset="2">

      </el-col>

      <el-col :span="24">
        <el-table
          :data="cnv_data"
          style="width: 100%"
          stripe
          :default-sort="{ prop: 'acmg_sig_num', order: 'descending' }"
          v-loading="loading_cnv"
          element-loading-text="Loading..."
          element-loading-spinner="icofont-refresh icofont-5x"
          element-loading-background="rgba(100, 100, 100, 0.5)"
          @sort-change="cnvSortChange"
          @selection-change="cnvSelectionChange"
          max-height="500"
          >
          <template slot="empty">
              <div v-if="loading_cnv">
              </div>
              <div v-else style="font-size: 20px; font-weight: 800; text-align: left">
                No CNV found
              </div>
          </template>

          <el-table-column
            v-if="g_examination_selected.status === 12"
            key="selection"
            type="selection"
            width="45"
            >
          </el-table-column>

          <el-table-column
            prop=""
            label="Flags"
            min-width="85"
            align="center"
            >
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.description_v > ''" :content="scope.row.description_v" placement="top" effect="light" :open-delay="500">
                <el-tag size="mini" type="info">CM</el-tag>
              </el-tooltip>
              <el-tooltip v-if="scope.row.selected == true" content="Signed Out Variant" placement="top" effect="light" :open-delay="500">
                <el-tag size="mini" effect="dark" type="success">SO</el-tag>
              </el-tooltip>
              <el-tooltip v-else-if="scope.row.selected == false" content="Preselected Variant" placement="top" effect="light" :open-delay="500">
                <el-tag size="mini" effect="dark" type="warning">PS</el-tag>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            label="Genes"
            min-width="250"
            align="left"
            sortable="custom"
            >
            <template #default="scope">
              <span></span>
              <!-- Loop through the first 3 genes -->
              <el-tag
                v-for="(gene, index) in scope.row.symbols.slice(0, 3)"
                :key="index"
                size="small"
                >
                {{ gene }}
              </el-tag>
              <!-- Display '+ xx others' if there are more than 3 genes with tooltip -->
              <el-tooltip
                v-if="scope.row.symbols.length > 3"
                effect="dark"
                :content="scope.row.symbols.slice(3).join(', ')"
                placement="top"
                >
                <template #content>
                  <el-tag v-for="(mygene, index1) in scope.row.symbols" size="small" :key="index1" type="info" style="cursor: pointer;">
                    {{ mygene }}
                  </el-tag>
                </template>

                <el-tag size="small" type="info" style="cursor: pointer;">
                  + {{ scope.row.symbols.length - 3 }} others
                </el-tag>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            key="int_sa"
            prop="int_sa"
            label="Int. A"
            width="70"
            align="center"
            sortable="custom"
            >
            <template #header>
              <el-tooltip
                content="Internal interpretation by expert A"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
                >
                <span style="cursor: help; text-decoration: underline;">Cl. A</span>
              </el-tooltip>
            </template>

            <template v-if="scope.row.int_sa >= 0" slot-scope="scope">
              <el-tooltip
                :content="scope.row.user_name_a"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
                >
                <el-button
                  :style="g_iclasses_style(scope.row.int_sa)"
                  size="small"
                  @click.native="click_modal_cnv_interpretation(scope.row.id_cnv, scope.row.int_sa, 'a', scope.row.description_v)"
                  >
                  {{ g_iclasses(scope.row.int_sa) }}
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            key="int_sb"
            prop="int_sb"
            label="Cl. B"
            width="70"
            align="center"
            sortable="custom"
            >
            <template #header>
              <el-tooltip
                content="Internal classification by expert B"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
                >
                <span style="cursor: help; text-decoration: underline;">Cl. B</span>
              </el-tooltip>
            </template>

            <template v-if="scope.row.int_sb >= 0" slot-scope="scope">
              <el-tooltip
                :content="scope.row.user_name_b"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <el-button
                  :style="g_iclasses_style(scope.row.int_sb)"
                  size="small"
                  @click.native="click_modal_cnv_interpretation(scope.row.id_cnv, scope.row.int_sb, 'b', scope.row.description_v)"
                >
                  {{ g_iclasses(scope.row.int_sb) }}
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>>

          <el-table-column
            key="f_proj_cnv"
            prop="f_proj_cnv"
            label="Freq / Proj"
            width="100"
            align="center"
            >
            <template #header>
              <el-tooltip
                content="Number of observations of the variant in this project (sequencing run)"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <span style="cursor: help; text-decoration: underline;">Freq / Proj</span>
              </el-tooltip>
            </template>

            <template slot-scope="scope">
              <el-badge
                type="primary"
                :value="scope.row.e_proj_cnv"
                class="badge_item"
              >
                <el-button
                  size="small"
                  @click.native="click_freq_proj(scope.row)"
                  >
                  {{ scope.row.f_proj_cnv }}
                </el-button>
              </el-badge>
            </template>
          </el-table-column>

          <el-table-column
            v-if="g_project.id_analysis_type === 1"
            key="f_wf1"
            prop="f_wf1"
            label="Freq / Som"
            width="100"
            align="center"
            >
            <!-- Header with improved tooltip -->
            <template #header>
              <el-tooltip
                content="Number of observations of the variant in the whole subject (somatic samples database)"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <span style="cursor: help; text-decoration: underline;">Freq / Som</span>
              </el-tooltip>
            </template>

            <!-- Row content -->
            <template slot-scope="scope">
              <el-badge
                type="info"
                :value="scope.row.e_wf1"
                class="badge_item"
              >
                <el-button
                  size="small"
                  @click.native="click_freq_subj(scope.row)"
                  >
                  {{ scope.row.f_wf1 }}
                </el-button>
              </el-badge>
            </template>
          </el-table-column>

          <el-table-column
            v-if="g_project.id_analysis_type === 2"
            key="f_wf2"
            prop="f_wf2"
            label="Freq / Germ"
            min-width="110"
            align="center"
            >
            <!-- Header with improved tooltip -->
            <template #header>
              <el-tooltip
                content="Number of observations of the variant in the whole subject (germline samples database)"
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <span style="cursor: help; text-decoration: underline;">Freq / Germ</span>
              </el-tooltip>
            </template>

            <!-- Row content -->
            <template slot-scope="scope">
              <el-badge
                type="info"
                :value="scope.row.e_wf2"
                class="badge_item"
              >
                <el-button
                  size="small"
                  @click.native="click_freq_subj(scope.row)"
                >
                  {{ scope.row.f_wf2 }}
                </el-button>
              </el-badge>
            </template>
          </el-table-column>

          <el-table-column
            prop="id_deldup"
            label="Type"
            min-width="120"
            align="center"
            >
            <template #default="scope">
              <span v-if="scope.row.id_deldup === 1" style="background-color: blue; color: white; padding: 2px 8px; border-radius: 4px;">
                {{ g_deldup(scope.row.id_deldup)["deldup"] }}
              </span>
              <span v-else-if="scope.row.id_deldup === 0" style="background-color: red; color: white; padding: 2px 8px; border-radius: 4px;">
                {{ g_deldup(scope.row.id_deldup)["deldup"] }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
            prop="acmg_sig_num"
            label="ACMG"
            align="center"
            sortable="custom"
            min-width="170"
            >
            <template slot-scope="scope">
              <!-- 1) ACMG label (text), fallback na číslo když by chyběl -->
              <span
                :style="{
                  backgroundColor: (scope.row.background_color || 'background-color: #666')
                    .replace('background-color: ', ''),
                  color: 'white',
                  padding: '4px 8px',
                  borderRadius: '4px'
                }"
              >
                {{ scope.row.acmg_sig || scope.row.acmg_sig_num }}
              </span>

              <br />

              <!-- 2) Links trigger + tooltip -->
              <el-tooltip
                effect="light"
                placement="top"
                :visible-arrow="false"
                popper-class="custom-tooltip"
                :open-delay="500"
              >
                <template #content>
                  <div style="color: black;">

                     <!-- CNV Variant Summary Header -->
                    <div style="margin-bottom: 12px; padding-bottom: 12px; border-bottom: 1px solid #ddd;">

                      <h4 style="margin: 0 0 8px 0; font-size: 16px; color: #006699; font-weight: bold;">
                        CNV variant
                      </h4>

                      <!-- CNV type -->
                      <div style="margin-bottom: 6px;">
                        <b>Type:</b>
                        <span
                          v-if="scope.row.id_deldup === 1"
                          style="background-color: blue; color: white; padding: 2px 8px; border-radius: 4px; margin-left: 4px;"
                        >
                          {{ g_deldup(scope.row.id_deldup)["deldup"] }}
                        </span>
                        <span
                          v-else-if="scope.row.id_deldup === 0"
                          style="background-color: red; color: white; padding: 2px 8px; border-radius: 4px; margin-left: 4px;"
                        >
                          {{ g_deldup(scope.row.id_deldup)["deldup"] }}
                        </span>
                        <span v-else style="color: gray; font-style: italic; margin-left: 4px;">
                          Unknown
                        </span>
                      </div>

                      <!-- CNV position -->
                      <div style="margin-bottom: 6px;">
                        <b>Position:</b>
                        <span v-if="scope.row.coordinates" style="margin-left: 4px;">
                          {{ scope.row.coordinates }}
                        </span>
                        <span v-else style="color: gray; font-style: italic; margin-left: 4px;">
                          No coordinates
                        </span>
                      </div>

                      <!-- CNV genes -->
                      <div>
                        <b>Genes:</b>

                        <span
                          v-if="scope.row.symbols && scope.row.symbols.length"
                          style="margin-left: 4px;"
                        >
                          <el-tag
                            v-for="(gene, index) in scope.row.symbols.slice(0, 3)"
                            :key="'cnv-link-header-gene-' + index"
                            size="mini"
                            style="margin-right: 3px;"
                          >
                            {{ gene }}
                          </el-tag>

                          <el-tooltip
                            v-if="scope.row.symbols.length > 3"
                            effect="light"
                            placement="top"
                            :open-delay="500"
                            popper-class="custom-tooltip"
                          >
                            <template #content>
                              <div style="max-width: 320px;">
                                <el-tag
                                  v-for="(mygene, index1) in scope.row.symbols"
                                  :key="'cnv-link-header-all-gene-' + index1"
                                  size="mini"
                                  type="info"
                                  style="margin: 2px;"
                                >
                                  {{ mygene }}
                                </el-tag>
                              </div>
                            </template>

                            <el-tag size="mini" type="info" style="cursor: pointer;">
                              + {{ scope.row.symbols.length - 3 }} others
                            </el-tag>
                          </el-tooltip>
                        </span>

                        <span v-else style="color: gray; font-style: italic; margin-left: 4px;">
                          No genes
                        </span>
                      </div>

                    </div>

                    <!-- Reference Variant Quality Section -->
                    <h4 style="margin: 0 0 8px 0; font-size: 16px; color: #cc6600; font-weight: bold;">
                      Reference Variant Quality
                    </h4>

                    <!-- UCSC (Session + Fallback) -->
                    <div style="margin-bottom: 8px;">

                      <!-- Primary: UCSC with Genovesa session -->
                      <a
                        v-if="scope.row && scope.row.coordinates"
                        :href="mylink_ucsc_cnv_session(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-globe" style="margin-right: 5px;"></i>
                        UCSC (Genovesa tracks)
                      </a>
                      <span v-else style="color: gray; font-style: italic;">UCSC - No coordinates</span>

                      <!-- Secondary: fallback without session -->
                      <a
                        v-if="scope.row && scope.row.coordinates"
                        :href="mylink_ucsc_cnv_default(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center; margin-top: 4px;"
                      >
                        <i class="fa fa-life-ring" style="margin-right: 5px;"></i>
                        UCSC (default fallback)
                      </a>

                    </div>

                    <!-- Variant Database Section -->
                    <div style="padding: 12px 0 0 0; border-top: 1px solid #ddd; margin-top: 12px;">
                      <h4 style="margin: 0 0 8px 0; font-size: 16px; color: #cc6600; font-weight: bold;">
                        Variant Database
                      </h4>
                    </div>

                    <!-- NCBI GDV -->
                    <div style="margin-bottom: 8px;">
                      <a v-if="scope.row && scope.row.coordinates"
                        :href="mylink_ncbi_gdv_cnv(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;">
                        <i class="fa fa-globe" style="margin-right: 5px;"></i> NCBI GDV
                      </a>
                      <span v-else style="color: gray; font-style: italic;">NCBI GDV - No coordinates</span>
                    </div>

                    <!-- gnomAD SV -->
                    <div style="margin-bottom: 8px;">
                      <a v-if="scope.row && scope.row.coordinates"
                        :href="mylink_gnomad_sv_region(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;">
                        <i class="fa fa-database" style="margin-right: 5px;"></i> gnomAD SV (region)
                      </a>
                      <span v-else style="color: gray; font-style: italic;">gnomAD SV - No coordinates</span>
                    </div>

                    <!-- ClinGen Dosage -->
                    <div style="margin-bottom: 8px;">
                      <a v-if="scope.row && scope.row.coordinates"
                        :href="mylink_clingen_region(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;">
                        <i class="fa fa-balance-scale" style="margin-right: 5px;"></i> ClinGen Dosage (region)
                      </a>
                      <span v-else style="color: gray; font-style: italic;">ClinGen - No coordinates</span>
                    </div>

                    <!-- DECIPHER -->
                    <div style="margin-bottom: 8px;">
                      <a v-if="scope.row && scope.row.coordinates"
                        :href="mylink_decipher_region(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;">
                        <i class="fa fa-search" style="margin-right: 5px;"></i> DECIPHER (region)
                      </a>
                      <span v-else style="color: gray; font-style: italic;">DECIPHER - No coordinates</span>
                    </div>

                    <!-- DGV -->
                    <div style="margin-bottom: 8px;">
                      <a v-if="scope.row && scope.row.coordinates"
                        :href="mylink_dgv_region(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;">
                        <i class="fa fa-database" style="margin-right: 5px;"></i> DGV (region)
                      </a>
                      <span v-else style="color: gray; font-style: italic;">DGV - No coordinates</span>
                    </div>

                    <!-- dbVar -->
                    <div style="margin-bottom: 8px;">
                      <a v-if="scope.row && scope.row.coordinates"
                        :href="mylink_dbvar_region(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;">
                        <i class="fa fa-database" style="margin-right: 5px;"></i> dbVar (region)
                      </a>
                      <span v-else style="color: gray; font-style: italic;">dbVar - No coordinates</span>
                    </div>

                    <!-- ClinVar -->
                    <div style="margin-bottom: 8px;">
                      <a v-if="scope.row && scope.row.coordinates"
                        :href="mylink_clinvar_region(scope.row)"
                        target="_blank"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;">
                        <i class="fa fa-hospital" style="margin-right: 5px;"></i> ClinVar (region)
                      </a>
                      <span v-else style="color: gray; font-style: italic;">ClinVar - No coordinates</span>
                    </div>

                    <!-- Clipboard Shortcuts -->
                    <div style="padding: 12px 0 0 0; border-top: 1px solid #ddd; margin-top: 12px;">
                      <h4 style="margin: 0 0 8px 0; font-size: 16px; color: #006699; font-weight: bold;">
                        Clipboard Shortcuts
                      </h4>
                    </div>

                    <!-- Copy CNV label (DEL/DUP + coordinates) -->
                    <div style="margin-bottom: 8px;">
                      <a v-if="scope.row && scope.row.coordinates"
                        href="#"
                        @click.prevent="copyToClipboard_cnv_label(scope.row)"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-copy" style="margin-right: 5px;"></i>
                        {{ cnv_copy_simple_label(scope.row) }}
                      </a>
                      <span v-else style="color: gray; font-style: italic;">Copy - No CNV label</span>
                    </div>

                    <!-- Copy Genes -->
                    <div style="margin-bottom: 8px;">
                      <a v-if="scope.row && scope.row.symbols && scope.row.symbols.length"
                        href="#"
                        @click.prevent="copyToClipboard_cnv_genes(scope.row)"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-copy" style="margin-right: 5px;"></i>
                        {{ formatCnvGenesDisplay(scope.row) }}
                      </a>
                      <span v-else style="color: gray; font-style: italic;">Copy - No genes</span>
                    </div>

                    <!-- Copy Coordinates -->
                    <div style="margin-bottom: 8px;">
                      <a v-if="scope.row && scope.row.coordinates"
                        href="#"
                        @click.prevent="copyToClipboard_cnv_coordinates(scope.row)"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-copy" style="margin-right: 5px;"></i>
                        {{ scope.row.coordinates }}
                      </a>
                      <span v-else style="color: gray; font-style: italic;">Copy - No coordinates</span>
                    </div>

                    <!-- Copy ISCN-like (pretty) -->
                    <div style="margin-bottom: 8px;">
                      <a
                        v-if="scope.row && scope.row.coordinates"
                        href="#"
                        @click.prevent="copyToClipboard_text(cnv_copy_iscn_like_pretty(scope.row), 'ISCN-like notation copied to clipboard')"
                        style="color: black; text-decoration: underline; display: flex; align-items: center;"
                      >
                        <i class="fa fa-copy" style="margin-right: 5px;"></i>
                        {{ cnv_copy_iscn_like_pretty(scope.row) }}
                      </a>
                      <span v-else style="color: gray; font-style: italic;">Copy - No ISCN</span>
                    </div>

                  </div>
                </template>

                <span style="cursor: pointer; text-decoration: underline; color: blue;">
                  Links
                </span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            prop="coordinates"
            label="Chr"
            min-width="80"
            sortable="custom"
            align="center"
            >
            <template slot-scope="scope">
              {{ scope.row.coordinates ? scope.row.coordinates.split(':')[0] : '' }}
            </template>
          </el-table-column>

          <el-table-column
            prop="cytoband"
            label="Cytoband"
            min-width="150"
            align="center"
            >
          </el-table-column>

          <el-table-column
            prop="sc_reads_rat"
            label="Reads ratio"
            align="center"
            sortable="custom"
            min-width="150"
            >
          </el-table-column>

          <el-table-column
            align="center"
            min-width="160"
            >
            <template #header>
              Reads <br /> (Observed / Expected)
            </template>
            <template slot-scope="scope">
              {{ scope.row.reads_observerd }} / {{ scope.row.reads_expected }}
            </template>
          </el-table-column>

          <el-table-column
            prop="length"
            label="Length"
            align="center"
            sortable="custom"
            min-width="150"
            >
          </el-table-column>

          <el-table-column
            prop="coordinates"
            label="Position"
            align="center"
            min-width="170"
            >
            <template slot-scope="scope">
              <a :href="mylink_pos_coord(scope.row.coordinates)" target="_blank">{{ scope.row.coordinates }}</a> <br /> <el-link v-if="igv_switch" @click.native="igv_search_coord(scope.row.coordinates)" icon="icofont-look" class="igv_modra"> IGV </el-link>
            </template>
          </el-table-column>

          <el-table-column
            prop="sc_bins"
            align="center"
            sortable="custom"
            min-width="150"
            >
            <template #header>
              <el-tooltip
                content="Bins represent the number of genomic regions (or bins) analyzed for CNV detection in ExomeDepth. More bins generally provide stronger evidence for a CNV."
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <span style="cursor: help; text-decoration: underline;">Bins</span>
              </el-tooltip>
            </template>

            <template #default="scope">
              {{ scope.row.sc_bins }}
            </template>
          </el-table-column>

          <el-table-column
            prop="sc_bf"
            align="center"
            sortable="custom"
            min-width="150"
            >
            <template #header>
              <el-tooltip
                content="BF (Bayesian Factor) indicates the strength of evidence for the presence of a CNV. Higher BF values suggest stronger evidence, while lower values indicate weaker evidence."
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
              >
                <span style="cursor: help; text-decoration: underline;">Quality</span>
              </el-tooltip>
            </template>

            <template #default="scope">
              {{ scope.row.sc_bf }}
            </template>
          </el-table-column>

          <el-table-column
            prop="omim_morbid"
            label="OMIM Morbid"
            align="center"
            sortable="custom"
            min-width="150"
            >
            <template #header>
              <el-tooltip
                content="OMIM Morbid refers to genes associated with known genetic disorders according to the OMIM database. If a gene is listed in this field, it may be implicated in a recognized genetic disease."
                placement="top"
                effect="light"
                :open-delay="500"
                popper-class="custom-tooltip"
                >
                <span style="cursor: help; text-decoration: underline;">OMIM Morbid</span>
              </el-tooltip>
            </template>

            <!-- Show content in the table row for this column -->
            <template #default="scope">
              {{ scope.row.omim_morbid }}
            </template>
          </el-table-column>

          <el-table-column
            prop="id_cnv"
            label="ID CNV"
            min-width="100"
            align="center"
            >
          </el-table-column>

        </el-table>
      </el-col>

      <el-col :span="12" :offset="12">
        <el-pagination
          class="pull-right pagination_mezera"
          @size-change="sizeChangePage"
          @current-change="currentChangePage"
          :current-page.sync="cnvs_props.currentPage"
          :page-sizes="cnvs_props.perPageOptions"
          :page-size="cnvs_props.perPage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="cnvs_props.total"
          background
          v-loading="loading_cnvt"
          element-loading-text="Loading..."
          element-loading-spinner="icofont-refresh icofont-2x"
          element-loading-background="rgba(100, 100, 100, 0.9)"
          >
        </el-pagination>
      </el-col>

    </el-row>


    <el-dialog :visible.sync="modal_cnv_interpretation" width="95%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true">
      <h5 slot="header" class="title title-up"> Change Internal Class: </h5>
      <form @submit.prevent="submit_formdata_change_class">
        <div class="row">
          <el-tabs class="col-md-12" type="card" @tab-click="iclass_tabs" v-model="mytab">
            <el-tab-pane :disabled="!formdata_change_class.pane_a && mytab_origin !== 'change_a'" label="Change value A" name="change_a">
              <div class="row">
                <div class="col-md-11 mr-auto ml-auto">
                    <label>Internal Classification A</label>
                    <div class="form-group">
                      <el-select class="select-info"
                                placeholder="Select value"
                                v-model="formdata_change_class.class_value_a">
                        <el-option v-for="one in l_iclasses"
                                  class="select-info"
                                  :value="one.id_iclass"
                                  :label="one.iclass"
                                  :key="one.id_iclass">
                        </el-option>
                      </el-select>
                    </div>

                    <label>Description of Change</label>
                      <el-input
                        type="textarea"
                        :rows="4"
                        autosize
                        maxlength="120"
                        v-model="formdata_change_class.description_a"
                        show-word-limit
                      >
                      </el-input>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane :disabled="!formdata_change_class.pane_b && mytab_origin !== 'change_b'" label="Change value B" name="change_b">
              <div class="row">
                <div class="col-md-11 mr-auto ml-auto">
                    <label>Internal Classification B</label>
                    <div class="form-group">
                      <el-select class="select-info"
                                placeholder="Select value"
                                v-model="formdata_change_class.class_value_b">
                        <el-option v-for="one in l_iclasses"
                                  class="select-info"
                                  :value="one.id_iclass"
                                  :label="one.iclass"
                                  :key="one.id_iclass">
                        </el-option>
                      </el-select>
                    </div>

                    <label>Description of Change</label>
                      <el-input
                        type="textarea"
                        :rows="4"
                        autosize
                        maxlength="120"
                        v-model="formdata_change_class.description_b"
                        show-word-limit
                      >
                      </el-input>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="Variant Comments" name="description">
              <div class="row">
                <div class="col-md-11 mr-auto ml-auto">
                  <div class="form-group">
                    <textarea type="textarea" :rows="15" class="form-control" placeholder="" v-model="formdata_change_class.description_v"> </textarea>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="History" name="history">
              <el-table
                :data="ints_history_data"
                stripe
                style="width: 100%"
                >
                <el-table-column
                  prop="iaa_user_name_a"
                  label="User Name A"
                  width="200"
                  align="center"
                  >
                </el-table-column>

                <el-table-column
                  prop="iclass_a"
                  label="IClass A"
                  width="200"
                  align="center"
                  >
                  <template v-if="scope.row.int_sa > 0" slot-scope="scope">
                      <el-button :style="g_iclasses_style(scope.row.int_sa)" size="small">{{ scope.row.iclass_a }}</el-button>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="iaa_user_name_b"
                  label="User Name B"
                  width="200"
                  align="center"
                  >
                </el-table-column>

                <el-table-column
                  prop="iclass_b"
                  label="IClass B"
                  width="200"
                  align="center"
                  >
                  <template v-if="scope.row.int_sb > 0" slot-scope="scope">
                      <el-button :style="g_iclasses_style(scope.row.int_sb)" size="small">{{ scope.row.iclass_b }}</el-button>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="made"
                  label="Made"
                  width="180"
                  align="center"
                  >
                </el-table-column>

                <el-table-column
                  prop="int_ta"
                  label="Note A"
                  >
                </el-table-column>

                <el-table-column
                  prop="int_tb"
                  label="Note B"
                  >
                </el-table-column>
              </el-table>
            </el-tab-pane>

            <el-tab-pane label="Partners" name="partner">
              <el-table
                :data="ints_partner_data"
                stripe
                style="width: 100%"
                >

                <el-table-column
                  prop="subject"
                  label="Partner"
                  min-width="300"
                  sortable="custom"
                  >
                </el-table-column>

                <el-table-column
                  prop="user_a"
                  label="User Name A"
                  min-width="200"
                  sortable="custom"
                  align="center"
                  >
                </el-table-column>

                <el-table-column
                  prop="t_int_sa"
                  label="IClass A"
                  min-width="180"
                  sortable="custom"
                  align="center"
                  >
                  <template v-if="scope.row.int_sa >= 0" slot-scope="scope">
                      <el-button :style="g_iclasses_style(scope.row.int_sa)" size="small">{{ scope.row.t_int_sa }}</el-button>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="user_b"
                  label="User Name B"
                  min-width="200"
                  sortable="custom"
                  align="center"
                  >
                </el-table-column>

                <el-table-column
                  prop="t_int_sb"
                  label="IClass B"
                  min-width="180"
                  sortable="custom"
                  align="center"
                  >
                  <template v-if="scope.row.int_sb >= 0" slot-scope="scope">
                      <el-button :style="g_iclasses_style(scope.row.int_sb)" size="small">{{ scope.row.t_int_sb }}</el-button>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="made"
                  label="Made"
                  min-width="200"
                  sortable="custom"
                  align="center"
                  >
                </el-table-column>

                <el-table-column
                  prop="int_ta"
                  label="Note A"
                  min-width="300"
                  >
                </el-table-column>

                <el-table-column
                  prop="int_tb"
                  label="Note B"
                  min-width="300"
                  >
                </el-table-column>
              </el-table>
            </el-tab-pane>

          </el-tabs>
        </div>

        <div class="row">
          <div class="col-md-11 mr-auto ml-auto">
            <button type="submit" class="btn btn-info" style="width: 100%">Submit</button>
          </div>
        </div>
      </form>
    </el-dialog>

  </div>

</template>

<script>
  import Vue from 'vue';
  import moment from 'moment';
  // import Button from 'src/components/UIComponents/Button';
  import Loading from 'src/components/Layout/LoadingMainPanel.vue';


  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import axios from 'axios';

  export default {
    name: 'cnvs_table',
    props: {
      global: {
        type: Boolean,
        default: false,
        description: ''
      },
    },
    components: {
    },


    data () {
      return {
        selected_cnv: [],
        show: true,
        modal_cnv_interpretation: false,
        ints_history_data: [],
        ints_partner_data: [],

        formdata_change_class: {
          id_cnv: 0,
          class_value_a: "",
          class_value_b: "",
          description_a: "",
          description_b: "",
          pane_a: false,
          pane_b: false,
          pane_v: false,
          description_v: "",
        },

        mytab: "",
        mytab_origin: "",

      }
    },

    computed: {
      ...mapState({
        cufi: state => state.cufi,
        cufi_yes: state => state.cufi_yes,
        id_project: state => state.id_project,
        id_workflow: state => state.id_workflow,
        id_examination: state => state.id_examination,
        selected_exams: state => state.selected_exams,
        l_iclasses: state => state.l_iclasses,
        l_deldups: state => state.l_deldups,

        loading_cnv: state => state.loading_cnv,
        loading_cnvt: state => state.loading_cnvt,

        vars_order: state => state.vars_order,
        cnvs_selected: state => state.cnvs_selected,

        user_setup: state => state.user_setup,

        token: state => state.token,
        user: state => state.user,
        id_biorole: state => state.id_biorole,
        subject: state => state.subject,
        application: state => state.application,
        app: state => state.app,
        rapp: state => state.rapp,
        app_version: state => state.app_version,

        dufi: state => state.dufi,
        cnv_data: state => state.cnv_data,
        cnvs_props: state => state.cnvs_props,
      }),

      ...mapGetters({
        g_examination: 'g_examination',
        g_examination_selected: 'g_examination_selected',
        g_project: 'g_project',
        g_deldup: 'g_deldup',
        g_iclasses: 'g_iclasses',
        g_iclasses_style: 'g_iclasses_style',
      }),


      vars_selected_tab: {
        get () { return this.$store.state.vars_selected_tab; },
        set (value) { this.$store.commit('m_vars_selected_tab', value); }
      },


      igv_switch: {
        get () { return this.$store.state.igv_switch; },
        set (value) { this.$store.commit('m_igv_switch', value); }
      },


    },


    methods: {
      ...mapMutations({
        m_igv_on: 'm_igv_on',
        m_igv_sest: 'm_igv_sest',
        m_igv_coord: 'm_igv_coord',
        m_vars_selected_tab: 'm_vars_selected_tab',
        m_id_examination: 'm_id_examination',

      }),


      ...mapActions({
        a_vars: 'a_vars',
        a_vars_badges: 'a_vars_badges',
        a_notify: 'a_notify',
        a_cnvs: 'a_cnvs',
        a_change_cnv_interpretation: 'a_change_cnv_interpretation',
        a_freq_cnv_data: 'a_freq_cnv_data',

      }),


      igv_search(row, event) {
        let sest = row.chrom + ":" + row.pos;
        this.m_igv_sest(sest);
        // igv.browser.search(sest);
      },


      iclass_tabs(tab, event) {
        if (tab.name == "change_a") {
          // this.formdata_change_class.pane_a = true;
          // this.formdata_change_class.pane_b = false;
          // this.formdata_change_class.pane_v = false;

        } else if (tab.name == "change_b") {
          // this.formdata_change_class.pane_a = false;
          // this.formdata_change_class.pane_b = true;
          // this.formdata_change_class.pane_v = false;

        } else if (tab.name == "description") {
          // this.formdata_change_class.pane_a = false;
          // this.formdata_change_class.pane_b = false;
          // this.formdata_change_class.pane_v = true;

          // axios.get(process.env.VUE_APP_BE + '/change_cnv_interpretation', { withCredentials: true, params: { "id_cnv": this.formdata_change_class.id_cnv, "what": "description" }, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', }})
          //     .then(response => {
          //       this.formdata_change_class.description_v = response.data["description_v"]
          //     }, error => {
          //         console.log(error);
          //     });

        } else if (tab.name == "history") {
          // this.formdata_change_class.pane_a = false;
          // this.formdata_change_class.pane_b = false;
          // this.formdata_change_class.pane_v = false;

          axios.get(process.env.VUE_APP_BE + '/change_cnv_interpretation', { withCredentials: true, params: { "id_cnv": this.formdata_change_class.id_cnv, "what": "history" }, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', }})
              .then(response => {
                this.ints_history_data = response.data["ints_history"]
              }, error => {
                  console.log(error);
              });

        } else if (tab.name == "partner") {
          // this.formdata_change_class.pane_a = false;
          // this.formdata_change_class.pane_b = false;
          // this.formdata_change_class.pane_v = false;

          axios.get(process.env.VUE_APP_BE + '/change_cnv_interpretation', { withCredentials: true, params: { "id_cnv": this.formdata_change_class.id_cnv, "what": "partner" }, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', }})
              .then(response => {
                this.ints_partner_data = response.data["ints_partner"]
              }, error => {
                  console.log(error);
              });

        }
        else {
          this.formdata_change_class.pane_a = false;
          this.formdata_change_class.pane_b = false;
          this.formdata_change_class.pane_v = false;
        }
      },


      cnvSortChange (val) {
        this.cnvs_props.currentPage = 1
        this.cnvs_props.prop = val.prop
        this.cnvs_props.order = val.order

        if (this.vars_selected_tab === "cnv") {
          this.a_cnvs( {  } );
        } else {
          this.a_cnvs( { "selected": this.cnvs_selected } );
        }

      },


      cnvSelectionChange (val) {
        this.selected_cnv = val;
      },


      mylink_pos(row) {
        return "http://www.ensembl.org/Homo_sapiens/Location/View?r=" + (row.chrom).substring(3) + ":" + row.pos + "-" + row.pos ;
      },


      mylink_cosmic(row) {
        return "https://cancer.sanger.ac.uk/cosmic/search?q=" + row.a_cosmic_coding ;
      },


      click_modal_cnv_interpretation ( id_cnv, myvalue, mytype, descr_v ) {
        this.formdata_change_class.id_cnv = id_cnv;
        this.formdata_change_class.description_a = "";
        this.formdata_change_class.description_b = "";

        if ( mytype == "a") {
          this.mytab = "change_a";
          this.mytab_origin = "change_a";
          this.formdata_change_class.class_value_a = myvalue;
          this.formdata_change_class.description_a = "";
          this.formdata_change_class.pane_a = true;
          this.formdata_change_class.pane_b = false;
          this.formdata_change_class.pane_v = true;
        } else if ( mytype == "b") {
          this.mytab = "change_b";
          this.mytab_origin = "change_b";
          this.formdata_change_class.class_value_b = myvalue;
          this.formdata_change_class.description_b = "";
          this.formdata_change_class.pane_a = false;
          this.formdata_change_class.pane_b = true;
          this.formdata_change_class.pane_v = true;
        }

        this.ints_history_data = [];
        this.formdata_change_class.id_cnv = id_cnv;
        this.formdata_change_class.description_v = descr_v;
        this.modal_cnv_interpretation = true;
      },


      submit_formdata_change_class() {
        this.a_change_cnv_interpretation( this.formdata_change_class );

        this.modal_cnv_interpretation = false;
        this.formdata_change_class.description_a = "";
        this.formdata_change_class.description_b = "";
      },


      click_class_a() {
        this.$prompt('Please input name', 'NEW FILTER', {
          confirmButtonText: 'CREATE NEW FILTER',
          cancelButtonText: 'Cancel',
        }).then(({ value }) => {
          this.dufi.id_dufi = null;
          this.dufi.dufi_name = value;

          axios.post(process.env.VUE_APP_BE + '/dufi', {"dufi": this.dufi}, { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
            .then(response => {

              this.$alert('New filter is ready.', 'NEW FILTER', {
                confirmButtonText: 'OK',
                callback: action => {
                  if (response.data["dufi_insert"] > 0) {
                    this.dufi_selected = response.data["dufi_insert"];
                    this.dufi.id_dufi = response.data["dufi_insert"];

                  }
                }
              });
            }, error => {
              console.log(error);
            });

        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Input canceled'
          });
        });

      },



      search_vars_by( event ) {
        event.stopImmediatePropagation();
        if (this.search_vars_by_select === "") {
          this.$alert('Select item for filtering first.', 'WRONG.', {
            confirmButtonText: 'OK',
          });
        } else {
          this.pagination_v.currentPage = 1;

          if (this.vars_selected_tab === "all") {
            this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": true, "selected": this.vars_selected } );
          } else if (this.vars_selected_tab === "default") {
            this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected } );
          } else if (this.vars_selected_tab === "presel") {
            this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected } );
          } else if (this.vars_selected_tab === "sign") {
            this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected } );
          } else {
            this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "er_switch": this.er_switch, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "full_yes": false, "cufi": this.cufi, "selected": this.vars_selected } );
          }

        }
      },


      preselect_cnv (event) {
        event.stopImmediatePropagation();

        if (this.selected_cnv.length > 0) {
          axios.post(process.env.VUE_APP_BE + '/preselect_cnv', { "id_project": this.id_project, "id_examination": this.id_examination, "selected_cnv": this.selected_cnv }, { withCredentials: true, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', } })
              .then(response => {
                if (response.data.resp_info > "") {
                  this.$alert('CNV were already signed out. Please first reset sign out to change.', 'Attention', {
                    confirmButtonText: 'OK',
                    type: "danger"
                  });
                } else {
                  this.$notify({
                    title: 'INFO',
                    message: 'CNV are moved to Preselected',
                    type: 'success',
                    position: 'top-right',
                  });
                }

                if (this.vars_selected_tab === "cnv") {
                  this.a_cnvs( {  } );
                } else {
                  this.a_cnvs( { "selected": this.cnvs_selected } );
                }

              }, error => {
                  console.log(error);
              });
        } else {
          this.$alert('No CNV are selected for the Preselect.', 'Warning', {
                    confirmButtonText: 'OK',
                    type: "warning"
                  });
        }
      },


      unpreselect_cnv (event) {
        event.stopImmediatePropagation();

        if (this.selected_cnv.length > 0) {
          axios.put(process.env.VUE_APP_BE + '/preselect_cnv', { "id_project": this.id_project, "id_examination": this.id_examination, "selected_cnv": this.selected_cnv }, { withCredentials: true, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', } })
              .then(response => {
                if (response.data.resp_info > "") {
                  this.$alert('CNV were already signed out. Please first reset sign out to change.', 'Attention', {
                    confirmButtonText: 'OK',
                    type: "danger"
                  });
                } else {
                  this.$notify({
                    title: 'INFO',
                    message: 'CNV are removed from Preselected',
                    type: 'success',
                    position: 'top-right',
                  });
                }

                if (this.vars_selected_tab === "cnv") {
                  this.a_cnvs( {  } );
                } else {
                  this.a_cnvs( { "selected": this.cnvs_selected } );
                }

              }, error => {
                  console.log(error);
              });
        } else {
          this.$alert('No CNV are selected for the Preselect.', 'Warning', {
                    confirmButtonText: 'OK',
                    type: "warning"
                  });
        }
      },


      sign_out_cnv (event) {
        event.stopImmediatePropagation();

        if (this.selected_cnv.length > 0) {
          axios.post(process.env.VUE_APP_BE + '/sign_out_cnv', { "id_project": this.id_project, "id_examination": this.id_examination, "selected_cnv": this.selected_cnv }, { withCredentials: true, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', } })
              .then(response => {
                if (response.data.resp_info > "") {
                  this.$alert('CNV were already signed out. Please first reset sign out to change.', 'Attention', {
                    confirmButtonText: 'OK',
                    type: "danger"
                  });
                } else {
                  this.$notify({
                    title: 'INFO',
                    message: 'CNV signed out',
                    type: 'success',
                    position: 'top-right',
                  });
                }

                if (this.vars_selected_tab === "cnv") {
                  this.a_cnvs( {  } );
                } else {
                  this.a_cnvs( { "selected": this.cnvs_selected } );
                }
              }, error => {
                  console.log(error);
              });
        } else {
          this.$alert('No CNV selected to be signed out.', 'Warning', {
                    confirmButtonText: 'OK',
                    type: "warning"
                  });
        }
      },


      export_all_cnvs(event){
        event.stopImmediatePropagation();
        // this.$alert('Export is not supported in this version...', 'Warning', {
        //     confirmButtonText: 'OK',
        //     type: "warning"
        //   });
        this.a_cnvs( { "export": 2 } );
      },


      export_grid_cnvs(event){
        event.stopImmediatePropagation();
        this.a_cnvs( { "export": 1 } );
      },


      currentChangePage(val) {
        this.cnvs_props.currentPage = val;

        if (this.vars_selected_tab === "cnv") {
          this.a_cnvs( {  } );
        } else {
          this.a_cnvs( { "selected": this.cnvs_selected } );
        }

      },


      sizeChangePage(val) {
        this.cnvs_props.perPage = val;

        if (this.vars_selected_tab === "cnv") {
          this.a_cnvs( {  } );
        } else {
          this.a_cnvs( { "selected": this.cnvs_selected } );
        }

      },


      igv_search_coord(coord) {
        this.m_igv_coord(coord);
        // igv.browser.search(coord);
      },


      click_freq_proj (row) {
        event.stopImmediatePropagation();
        this.freq_type = "List of samples sharing the same variants in current project";
        this.a_freq_cnv_data( {"row": row, "which": "proj"} );
      },


      click_freq_subj (row) {
        event.stopImmediatePropagation();
        this.freq_type = "List of samples sharing the same variants";
        this.a_freq_cnv_data( {"row": row, "which": "subj"} );
      },


      watch_rapp () {
        if (this.rapp === "fastras") {
          this.user_setup.vars_grid_size = "S";
        } else {
          this.user_setup.vars_grid_size = "L";
        }
      },


      watch_id_examination (newid, oldid) {
        if (newid !== oldid) {
          if (this.igv_switch) {
            this.m_igv_switch(false);
          }
        }
      },


      mylink_pos_coord(coord) {
        let xcoord = "" + coord;
        return "http://www.ensembl.org/Homo_sapiens/Location/View?r=" + xcoord.substring(3);
      },


      mylink_ucsc_cnv_session(row) {
        const coord = (row && row.coordinates) ? ("" + row.coordinates).trim() : "";
        if (!coord) return "#";

        const base = "https://genome.ucsc.edu/cgi-bin/hgTracks";

        const qs =
          "db=hg38" +
          "&lastVirtModeType=default" +
          "&lastVirtModeExtraState=" +
          "&virtModeType=default" +
          "&virtMode=0" +
          "&nonVirtPosition=" +
          "&hgS_doOtherUser=submit" +
          "&hgS_otherUserName=zgtman" +
          "&hgS_otherUserSessionName=Genovesa_CNV" +
          "&position=" + encodeURIComponent(coord);

        return base + "?" + qs;
      },

      mylink_ucsc_cnv_default(row) {
        const coord = (row && row.coordinates) ? ("" + row.coordinates).trim() : "";
        if (!coord) return "#";

        // fallback bez session
        return (
          "https://genome.ucsc.edu/cgi-bin/hgTracks" +
          "?db=hg38" +
          "&lastVirtModeType=default" +
          "&lastVirtModeExtraState=" +
          "&virtModeType=default" +
          "&virtMode=0" +
          "&nonVirtPosition=" +
          "&position=" + encodeURIComponent(coord)
        );
      },


      mylink_ucsc_cnv(row) {
        return this.mylink_ucsc_cnv_session(row);
      },

      // --- helpers ---
      cnv_coord_to_parts(coord) {
        // očekává "chr4:54739049-54739548"
        if (!coord) return null;
        const m = ("" + coord).trim().match(/^chr([^:]+):(\d+)[-–](\d+)$/);
        if (!m) return null;
        return { chr: m[1], start: m[2], end: m[3] };
      },

      cnv_first_gene(row) {
        const genes = (row && row.symbols) ? row.symbols : [];
        return genes.length ? genes[0] : "";
      },

      // --- NCBI Genome Data Viewer (region) ---
      mylink_ncbi_gdv_cnv(row) {
        const parts = this.cnv_coord_to_parts(row && row.coordinates);
        if (!parts) return "#";

        // GDV expects chr without "chr" prefix (e.g. chr=7 in NCBI example)
        const chrPlain = parts.chr; // "11" (ne "chr11")

        return (
          "https://www.ncbi.nlm.nih.gov/gdv/browser/genome/" +
          "?id=GCF_000001405.40" +                 // GRCh38.p14
          "&chr=" + encodeURIComponent(chrPlain) + // <-- TADY je fix
          "&from=" + encodeURIComponent(parts.start) +
          "&to=" + encodeURIComponent(parts.end)
        );
      },

      // --- gnomAD SV (region) ---
      mylink_gnomad_sv_region(row) {
        const parts = this.cnv_coord_to_parts(row && row.coordinates);
        if (!parts) return "#";

        const region = `${parts.chr}-${parts.start}-${parts.end}`; // bez "chr"
        return "https://gnomad.broadinstitute.org/region/" + encodeURIComponent(region) + "?dataset=gnomad_sv_r4";
      },

      // --- ClinGen Dosage Sensitivity (gene-level) ---
      formatWithCommas(n) {
        const s = String(n);
        return s.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },

      mylink_clingen_region(row) {
        const parts = this.cnv_coord_to_parts(row && row.coordinates);
        if (!parts) return "#";

        const loc =
          "chr" + parts.chr + ":" +
          this.formatWithCommas(parts.start) + "-" +
          this.formatWithCommas(parts.end);

        return "https://dosage.clinicalgenome.org/region_search_38.cgi?loc=" + encodeURIComponent(loc);
      },

      // --- DECIPHER (gene search) ---
      mylink_decipher_region(row) {
        const coord = (row && row.coordinates) ? ("" + row.coordinates).trim() : "";
        if (!coord) return "#";

        // Region query (zkusí přímo coord string)
        return "https://www.deciphergenomics.org/search?q=" + encodeURIComponent(coord);
      },

      copyToClipboard_cnv_genes(row) {
        const text = this.cnv_genes_all_text(row);
        this.copyToClipboard_text(text, 'Genes copied to clipboard');
      },

      mylink_dgv_region(row) {
        const coord = (row && row.coordinates) ? ("" + row.coordinates).trim() : "";
        if (!coord) return "#";

        // DGV: nejstabilnější je použít vyhledávání přes textový dotaz
        // (UI endpoint se může měnit, ale fulltext query bývá nejodolnější)
        // Použijeme formát "chr#:start-end"
        return "http://dgv.tcag.ca/gb2/gbrowse/dgv2_hg38/?name=" + encodeURIComponent(coord);
      },

      mylink_dbvar_region(row) {
        const coord = (row && row.coordinates) ? ("" + row.coordinates).trim() : "";
        if (!coord) return "#";

        // NCBI dbVar: region dotaz přes NCBI search
        // dbvar je součást NCBI, region query funguje jako text
        return "https://www.ncbi.nlm.nih.gov/dbvar/?term=" + encodeURIComponent(coord + "[CHRPOS]");
      },

      mylink_clinvar_region(row) {
        const coord = (row && row.coordinates) ? ("" + row.coordinates).trim() : "";
        if (!coord) return "#";

        // ClinVar: region query přes NCBI (spolehlivé)
        // Přidáme db=clinvar a term=chr:start-end
        return "https://www.ncbi.nlm.nih.gov/clinvar/?term=" + encodeURIComponent(coord);
      },

      // univerzální copy helper + notifikace
      copyToClipboard_text(text, notifyMsg) {
        const t = (text !== null && text !== undefined) ? ("" + text).trim() : "";
        if (!t) return;

        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(t);
        } else {
          const el = document.createElement('textarea');
          el.value = t;
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
        }

        this.$notify({
          title: 'INFO',
          message: notifyMsg || 'Copied to clipboard',
          type: 'success',
          position: 'top-right',
        });
      },

      formatCnvGenesDisplay(row) {
        const genesRaw = (row && row.symbols) ? row.symbols : [];
        const genes = Array.isArray(genesRaw)
          ? genesRaw
          : (("" + genesRaw).split(/[,; ]+/).filter(Boolean));

        if (!genes.length) return "";
        const top = genes.slice(0, 4);
        const rest = genes.length - top.length;
        return rest > 0 ? (top.join(', ') + ", ...") : top.join(', ');
      },

      cnv_genes_all_text(row) {
        const genesRaw = (row && row.symbols) ? row.symbols : [];
        const genes = Array.isArray(genesRaw)
          ? genesRaw
          : (("" + genesRaw).split(/[,; ]+/).filter(Boolean));
        return genes.join(', ');
      },

      cnv_deldup_label(row) {
        if (!row || row.id_deldup === null || row.id_deldup === undefined) {
          return "CNV";
        }

        try {
          const deldupInfo = this.g_deldup(row.id_deldup);

          if (deldupInfo && deldupInfo.deldup) {
            const deldup = ("" + deldupInfo.deldup).trim().toLowerCase();

            if (
              deldup.indexOf("del") >= 0 ||
              deldup.indexOf("deletion") >= 0
            ) {
              return "DEL";
            }

            if (
              deldup.indexOf("dup") >= 0 ||
              deldup.indexOf("duplication") >= 0
            ) {
              return "DUP";
            }
          }
        } catch (e) {
          // fallback below
        }

        return "CNV";
      },

      cnv_copy_simple_label(row) {
        const coord = (row && row.coordinates) ? ("" + row.coordinates).trim() : "";
        if (!coord) return "";
        return this.cnv_deldup_label(row) + " " + coord;
      },

      copyToClipboard_cnv_label(row) {
        const text = this.cnv_copy_simple_label(row);
        this.copyToClipboard_text(text, 'CNV label copied to clipboard');
      },

      copyToClipboard_cnv_genes(row) {
        const text = this.cnv_genes_all_text(row);
        this.copyToClipboard_text(text, 'Genes copied to clipboard');
      },

      copyToClipboard_cnv_coordinates(row) {
        const text = (row && row.coordinates) ? ("" + row.coordinates).trim() : "";
        this.copyToClipboard_text(text, 'Coordinates copied to clipboard');
      },

      cnv_copy_number_iscn(row) {
        const cnvType = this.cnv_deldup_label(row);

        if (cnvType === "DEL") {
          return "x1";
        }

        if (cnvType === "DUP") {
          return "x3";
        }

        return "x?";
      },

      cnv_copy_iscn_like_pretty(row) {
        const parts = this.cnv_coord_to_parts(row && row.coordinates);
        if (!parts) return "";

        // Band: ideálně "21q22.3" (chrNumber + cytoband), fallback "chr21"
        const cyt = (row && row.cytoband) ? ("" + row.cytoband).trim() : "";
        const band = cyt ? (parts.chr + cyt) : ("chr" + parts.chr);

        const startPretty = this.formatWithCommas(parts.start);
        const endPretty = this.formatWithCommas(parts.end);

        // V závorce ISCN-like: start_end (underscore)
        const cn = this.cnv_copy_number_iscn(row);

        return "arr[GRCh38] " + band + "(" + startPretty + "_" + endPretty + ")" + cn;
      },

//konec
    },

    beforeMount () {

    },


    created () {

    },


    mounted () {

    },


    afterDestroy () {

    },


    watch: {
      rapp: {
        handler: 'watch_rapp',
        immediate: true
      },

      id_examination: {
        handler: 'watch_id_examination',
        immediate: true
      },


    },


  }
</script>

<style lang="scss" scoped>
  body {
    margin: 0;
  }

  .el-table .td-actions{
    button.btn {
      margin-right: 5px;
    }
  }

  .btn {
    margin-left: 5px !important;
    margin-right: 5px !important;
  }

  .el-table {
    // font-size: 13px !important;
    // color: black !important;

  }

  .el-table .cell{
    line-height: 20px !important;
    word-break: break-word !important;
  }

  .el-table td, .el-table th {
    padding: 3px 0 !important;
  }

  .el-table .row_0 {
    background: #e6e6e6 !important;
  }

  .el-table .row_1 {
    background: rgb(243, 245, 152) !important;
  }

  .el-table .row_2 {
    background: rgb(248, 221, 171) !important;
  }

  .el-table .row_3 {
    background: rgb(248, 186, 157) !important;
  }

  .el-table .row_4 {
    background: rgb(197, 248, 208) !important;
  }

  .el-table .row_9 {
    background: rgb(250, 197, 184) !important;
  }



  .el-table .warning-row {
    background: rgb(241, 175, 52) !important;
  }

  .el-table .success-row {
    background: #a7ffb9 !important;
  }

  .el-table .danger-row {
    background: #f34c19 !important;
  }

  .el-table .info-row .el-tabs--border-card {
    background: #ffece8 !important;
  }

  .hranaty {
    border-radius: 2px !important;
  }

  h4 {
    margin-top: 5px !important;
  }

  .dolu {
    padding-top: 80px !important;
  }

  .table > thead > tr > th, .el-table table > thead > tr > th {
    // font-size: 13px !important;
  }

  .mezera {
    margin-right: 10px !important;
  }

  .bottom_margin_30 {
    margin-bottom: 30px;
  }

  .bottom_margin_10 {
    margin-bottom: 10px;
  }

  .top_margin_10 {
    margin-top: 10px;
  }

  .top_margin_30 {
    margin-top: 30px;
  }

  .top_margin_50 {
    margin-top: 50px;
  }

  .bg_gray {
    background: #e2e4e5 !important;
  }

  .bg_white {
    background-color: #FFF !important;
  }

  .gene_blue {
    background-color: #ccfdf3 !important;
    margin-left: 0px !important;
    border-radius: 6px !important;
  }

  .el-tag {
      border-radius: 2px !important;
      margin-left: 3px !important;
      margin-bottom: 3px !important;
      color: black !important;
      font-weight: 600 !important;
  }

  .bg_white_tab {
    background-color: #FFF !important;
    z-index: 9999 !important;
  }

  .el-row {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #eee;
    min-height: 12px;
    padding-left: 4px !important;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 18px;
  }

  .row-bg {
    padding: 3px 0;
    background-color: #f9fafc;
  }
  .el-table .cell {
      word-break: break-word;
  }

  .small_label {
      font-size: 10px !important;
      padding-top: 2px !important;
      padding-right: 4px !important;
  }

  .min_height {
    border-radius: 4px;
    height: 30px !important;
  }

  .popover_bg {
    background: #a3bbf1;
  }

  .pagination_mezera {
    margin-top: 25px !important;
  }

  .caret-wrapper {
    display: block !important;
  }

  .igv_modra {
    color: #409EFF !important;
  }

  .badge_item {
    margin-top: 10px;
    margin-right: 10px;
  }

  .custom-tooltip .el-tooltip__popper {
    background-color: #fff !important; /* Light background for the tooltip */
    border: 1px solid #ddd;            /* Optional: Subtle border around the tooltip */
    padding: 8px;                      /* Padding inside the tooltip */
    font-size: 14px;                   /* Adjust font size */
    color: black;                      /* Ensure the text color is black */
  }

  .custom-tooltip .el-tooltip__content {
    color: black;                      /* Ensure the content text is black */
  }


</style>
